import { MarketLevel } from '@ps/isp-web-services-types';

export const getIsScoreboardSupportedMarketLevel = (marketLevels?: MarketLevel[]) => {
  // always show scoreboards for bet events with no market level set
  if (!marketLevels || marketLevels.length === 0) return true;

  // only show scoreboards on AVB_EVENT events - filters out outright markets
  return marketLevels.includes(MarketLevel.AVB_EVENT);
};
